import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FaPlus } from 'react-icons/fa';
import { deleteBookingShuttle, removeShuttleDocument } from 'redux/booking/travel/travelBookingSlice';
import { Button, Confirmation } from 'components/common';
import OtherItem from './OtherItem';
import OtherForm from './OtherForm';

const OtherList = ({ booking }) => {
  const [showModalOther, setShowModalOther] = useState(false);
  const [showConfirmationDelete, setShowConfirmationDelete] = useState(false);
  const [shuttle, setShuttle] = useState(null);
  const { shuttles } = booking;

  const bookingId = booking.id;
  const dispatch = useDispatch();

  const handleEditOtherBooking = (s) => { setShuttle(s); setShowModalOther(true); };
  const handleCreateRecordBooking = () => { setShuttle(null); setShowModalOther(true); };
  const handleDeleteOtherBooking = (s) => { setShuttle(s); setShowConfirmationDelete(true); };
  const handleRemoveAttachment = (shuttleId, documentId) => dispatch(removeShuttleDocument({ bookingId, shuttleId, documentId }));

  const handleOkConfirm = () => {
    dispatch(deleteBookingShuttle({ bookingId, shuttleId: shuttle.id }));
    setShowConfirmationDelete(false);
  };

  const shuttleOthers = (shuttles || []).filter((s) => s.other === true);

  return (
    <>
      <div className="tw-flex tw-justify-end tw-mb-3">
        <Button size="sm" variant="secondary" leftIcon={FaPlus} onClick={handleCreateRecordBooking}>New record booking</Button>
      </div>

      {shuttleOthers.map((s) => (
        <OtherItem
          key={s.id}
          booking={booking}
          record={s}
          editShuttleBooking={() => handleEditOtherBooking(s)}
          deleteShuttleBooking={() => handleDeleteOtherBooking(s)}
          handleRemoveAttachment={handleRemoveAttachment}
        />
      ))}

      <Confirmation
        show={showConfirmationDelete}
        type="danger"
        title="Delete record"
        message="Are you sure to delete?"
        confirmText="Delete"
        onConfirm={handleOkConfirm}
        onCancel={() => setShowConfirmationDelete(false)}
      />

      <OtherForm showModal={showModalOther} setshowModal={setShowModalOther} booking={booking} record={shuttle} />
    </>
  );
};

OtherList.propTypes = {
  booking: PropTypes.object.isRequired,
};

export default OtherList;
